"use client";

import type { FormEvent, ReactNode } from "react";

interface FormComponentProps {
  children: ReactNode;
  onSubmit?: (e: FormEvent) => void;
}

export const FormComponent = ({ children, onSubmit }: FormComponentProps) => (
  <form className="form" onSubmit={onSubmit}>
    {children}
  </form>
);
